import type { EventDetailsPageProps } from './contracts';

export async function MountEventDetailsPage(props: EventDetailsPageProps, el: Element) {
	const module = await import('./event-details-page');
	module.MountEventDetailsPage(props, el);
}

window.MountEventDetailsPage = MountEventDetailsPage;
